const React = require('react');
const { createElement: h, useState } = React;
const apiClient = require('../lib/apiClient');
require('./ExtensionAuthPage.css');

function ExtensionAuthPage(props) {
  var [userCode, setUserCode] = useState(readCodeFromLocation());
  var [busy, setBusy] = useState(false);
  var [error, setError] = useState('');
  var [approvedDevice, setApprovedDevice] = useState('');

  function openLogin() {
    try {
      sessionStorage.setItem('alleflow_auth_return_to', window.location.pathname + window.location.search);
    } catch (_) {}
    props.onNavigateTo('/login');
  }

  function approve(event) {
    event.preventDefault();
    setBusy(true);
    setError('');
    apiClient.request('/extension-auth/device/approve', {
      method: 'POST',
      body: { userCode: userCode }
    }).then(function(result) {
      setApprovedDevice((result && result.deviceName) || 'Chrome extension');
    }).catch(function(requestError) {
      setError(requestError && requestError.message ? requestError.message : 'Could not approve this device.');
    }).finally(function() {
      setBusy(false);
    });
  }

  if (approvedDevice) {
    return h('main', { className: 'extension-auth-page' },
      h('section', { className: 'extension-auth-card extension-auth-success' },
        h('div', { className: 'extension-auth-icon', 'aria-hidden': 'true' }, '✓'),
        h('p', { className: 'extension-auth-eyebrow' }, 'Device connected'),
        h('h1', null, 'Alleflow is ready in Chrome'),
        h('p', null, approvedDevice + ' can now list and run your Browser Action workflows. You can close this tab and reopen the extension.'),
        h('button', { type: 'button', className: 'extension-auth-primary', onClick: function() { props.onNavigateTo('/dashboard'); } }, 'Open dashboard')
      )
    );
  }

  return h('main', { className: 'extension-auth-page' },
    h('section', { className: 'extension-auth-card' },
      h('div', { className: 'extension-auth-brand' },
        h('span', { 'aria-hidden': 'true' }, '↪'),
        h('div', null, h('strong', null, 'AlleFlow'), h('small', null, 'Browser Engine'))
      ),
      h('p', { className: 'extension-auth-eyebrow' }, 'Chrome device authorization'),
      h('h1', null, props.currentUser ? 'Approve this extension?' : 'Sign in to approve'),
      h('p', null, props.currentUser
        ? 'Only approve if this code matches the one shown in your Alleflow extension. The extension receives a revocable workflow token, never your password.'
        : 'Sign in to your Alleflow account, then you will return here to approve the Chrome extension.'),
      h('form', { onSubmit: approve },
        h('label', null, 'Authorization code',
          h('input', {
            value: userCode,
            onChange: function(event) { setUserCode(formatCode(event.target.value)); },
            placeholder: 'ABCD-2345',
            maxLength: 9,
            autoComplete: 'one-time-code',
            disabled: busy
          })
        ),
        props.currentUser
          ? h('div', { className: 'extension-auth-account' },
              h('span', null, 'Approving as'),
              h('strong', null, props.currentUser.username || props.currentUser.email || 'Alleflow user')
            )
          : null,
        error ? h('div', { className: 'extension-auth-error', role: 'alert' }, error) : null,
        props.currentUser
          ? h('button', { type: 'submit', className: 'extension-auth-primary', disabled: busy || userCode.length !== 9 }, busy ? 'Approving…' : 'Approve Chrome device')
          : h('button', { type: 'button', className: 'extension-auth-primary', onClick: openLogin }, 'Sign in to Alleflow')
      )
    )
  );
}

function readCodeFromLocation() {
  if (typeof window === 'undefined') return '';
  return formatCode(new URLSearchParams(window.location.search).get('code') || '');
}

function formatCode(value) {
  var compact = String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 8);
  return compact.length > 4 ? compact.slice(0, 4) + '-' + compact.slice(4) : compact;
}

module.exports = ExtensionAuthPage;
